module.exports = __webpack_public_path__ + "img/f8.f0ae39e8.png";